import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const MessagesApi = createApi({
  reducerPath: "messages",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    InternalNotes: builder.mutation({
      query: (body) => ({
        url: "v1/tickets/internal-note/",
        method: "POST",
        body,
      }),
    }),
    getTicketTemplate: builder.query({
      query: () => ({
        url: `v1/emails/templates/team/?page=1&template_for=ticket`,
        method: "GET",
      }),
    }),

  }),
});

export const { useInternalNotesMutation,useGetTicketTemplateQuery } = MessagesApi;